export const data = [
    // '../../assets/custom-image/project/device/Composite-smoke-sensing.svg',
    // '../../assets/custom-image/project/device/fuel-gas.svg',
    {
        name:'composite-smoke-sensing',
        icon:require('../../assets/custom-image/project/device/Composite-smoke-sensing.svg'),
        devName:'复合型烟感',
        devType:'sscdt'
    },
    {
        name:'fuel-gas',
        icon:require('../../assets/custom-image/project/device/fuel-gas.svg'),
        devName:'家用燃气报警器',
        devType:'dgat'
    },
    {
        name:'4G-gas',
        icon:require('../../assets/custom-image/project/device/4g-gas.svg'),
        devName:'4G燃气主机',
        devType:'gahft'
    },
    // {
    //     name:'smoke-detector',
    //     icon:'../../assets/custom-image/project/device/smoke-detector.svg',
    //     devName:'烟感'
    // }
]

const getIcon = (type)=>{
    for(let i = 0;i<data.length;i++){
        if(type == data[i].devType){
            return data[i].icon;
        }
    }
}

export {
    getIcon
}